import { render, staticRenderFns } from "./VerticalProductsColumn.vue?vue&type=template&id=688f492a&"
import script from "./VerticalProductsColumn.vue?vue&type=script&lang=js&"
export * from "./VerticalProductsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports